export default __webpack_public_path__ + "../img/74b6029220dd51e8f6e3e0acf0328731.png";